import { useState } from '#app'
import { DEFAULT_RETURN } from '~/utils/settingsReturn'

/**
 * Where back from Settings goes (utils/settingsReturn.ts). Written by the
 * router guard in plugins/settings-return.client.ts as Settings is entered;
 * read by the Settings screen for its back arrow.
 */
export function useSettingsReturn() {
  return useState<string>('settings-return', () => DEFAULT_RETURN)
}
